import { Box, Stack, styled } from "@mui/material"
import type { PropsWithChildren, ReactNode } from "react"
import { PageTitle, type PageTitleLevel, getHeaderHeight } from "../PageHeader"

export type FullWidthHeaderLayoutBaseProps = {
  subtitle?: string
} & MinimalProps

type MinimalProps = {
  title: string | ReactNode
  level?: PageTitleLevel
  chip?: ReactNode
}

export const TitleContainer = ({
  level,
  title,
  chip,
  children,
}: PropsWithChildren<MinimalProps>) => {
  return (
    <Stack gap={1} width="100%">
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        minWidth="180px"
        width="100%"
      >
        <PageTitle level={level}>{title}</PageTitle>
        {chip}
      </Stack>
      {children}
    </Stack>
  )
}

export const FullWidthHeaderLayout = styled(Box)(({ theme }) => ({
  position: "relative",
  height: getHeaderHeight(theme),
  marginBottom: theme.spacing(6),
}))

export const TopTitleContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(-4),
}))
